module.exports = __webpack_public_path__ + "img/shangbao.7952eef0.png";